import { PublicMeterResponse } from "@/api/model"

export const isValidReading = (
  reading: (string | undefined)[],
  digitCount?: number,
) => digitCount && reading.filter(Boolean).length === digitCount

export const allReadingsAreValid = (
  meter: PublicMeterResponse,
  readings: (string | undefined)[][],
) =>
  meter.registers?.every((register, index) =>
    isValidReading(readings[index] ?? [], register.digitCount),
  )

export const isEmptyReading = (reading: (string | undefined)[]) => {
  const cleanReading = reading.filter(Boolean)

  if (cleanReading.length === 0) return true

  return parseInt(cleanReading.join("")) === 0
}

export const isAllReadingsEmpty = (
  meter: PublicMeterResponse,
  readings?: (string | undefined)[][],
) => {
  if (!meter.registers || !readings) return true

  return meter.registers.every((_, index) =>
    isEmptyReading(readings[index] ?? []),
  )
}
